import { TIChartPointModel } from "./ti-chart-point.model";

export class TIIndicatorPointModel extends TIChartPointModel {
    public value = 0;
    
    constructor(data: any) {
        super(data)
        this.value = data.value;
    }

    public pointColorToClassName(name: string): string {
        const color = this.color.split(' ').join('').replace(/[^\w\s]/gi, '').toLowerCase();
        return name + '_' + color;
    }
}